"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  useCarousel: true
};
exports.default = void 0;
exports.useCarousel = useCarousel;
var _react = require("react");
var _useCarousel = require("./_useCarousel.types");
Object.keys(_useCarousel).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _useCarousel[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _useCarousel[key];
    }
  });
});
function useCarousel({
  slides = [],
  autoRotate = false,
  autoRotateDuration = 3000,
  pageSize = 1,
  stepSize = 0,
  slideIndex = 0,
  noWrap = false
} = {}) {
  const [currentPageIndex, setCurrentPageIndex] = (0, _react.useState)(Math.max(0, Math.min(slideIndex, (slides === null || slides === void 0 ? void 0 : slides.length) ? slides.length - 1 : 0)));
  const slideCount = slides.length;
  const getPageCount = (total, _pageSize, _stepSize) => _stepSize >= 1 ? total : Math.ceil(total / _pageSize);
  const [pageCount, setPageCount] = (0, _react.useState)(getPageCount(slideCount, pageSize, stepSize));
  const nextPage = () => {
    if (!stepSize) {
      setCurrentPageIndex(currentPage => {
        const nextPageValue = (currentPage + 1) % pageCount;
        if (noWrap && nextPageValue === 0) {
          return currentPage;
        }
        return nextPageValue;
      });
    } else {
      setCurrentPageIndex(currentPage => {
        const maxNextValue = pageCount - pageSize;
        if (currentPage >= maxNextValue) {
          if (noWrap) {
            return currentPage;
          }
          return 0;
        }
        const nextPageValue = (currentPage + stepSize) % pageCount;
        return nextPageValue + Math.min(maxNextValue - nextPageValue, 0);
      });
    }
  };
  const previousPage = () => {
    if (!stepSize) {
      setCurrentPageIndex(currentPage => {
        const newPageValue = (currentPage - 1 + pageCount) % pageCount;
        if (noWrap && newPageValue === pageCount - 1) {
          return currentPage;
        }
        return newPageValue;
      });
    } else {
      setCurrentPageIndex(currentPage => {
        const minPrevValue = pageCount - pageSize;
        if (currentPage <= 0) {
          return noWrap ? 0 : minPrevValue;
        }
        const newPrevValue = (currentPage - stepSize + pageCount) % pageCount;
        if (newPrevValue > minPrevValue) {
          return 0;
        }
        return newPrevValue;
      });
    }
  };
  const goToPage = index => {
    setCurrentPageIndex(index);
  };
  const getPagedSlides = () => {
    const start = currentPageIndex * pageSize;
    const end = start + pageSize;
    return slides.slice(start, end);
  };
  (0, _react.useEffect)(() => {
    setPageCount(getPageCount(slideCount, pageSize, stepSize));
    if (!autoRotate) return () => {};
    const interval = setInterval(() => {
      nextPage();
    }, autoRotateDuration);
    return () => clearInterval(interval);
  }, [slides, pageSize, stepSize, autoRotate, autoRotateDuration, noWrap]);
  const slideIndicesOnCurrentPage = Array(slideCount).fill(0).map((_, index) => index).slice(!stepSize ? currentPageIndex * pageSize : currentPageIndex, !stepSize ? currentPageIndex * pageSize + pageSize : currentPageIndex + pageSize);
  const isSlideOnPageFn = index => slideIndicesOnCurrentPage.includes(index);
  return {
    currentPageIndex,
    currentSlide: getPagedSlides(),
    pageCount,
    pageSize,
    slideCount,
    slidesOnCurrentPage: currentPageIndex === pageCount - 1 ? slideCount % pageSize : pageSize,
    slideIndicesOnCurrentPage,
    isOnFirstPage: currentPageIndex === 0,
    isOnLastPage: !stepSize ? currentPageIndex === pageCount - 1 : currentPageIndex === slideCount - pageSize,
    isSlideOnPageFn,
    nextPage,
    prevPage: previousPage,
    goToPage
  };
}
var _default = exports.default = useCarousel;